import personTranslations from "./personTranslations";
import { Roles } from "../../types/BackofficeUser";

const backofficeUserTranslations = {
  roles: {
    label: "Rollen",
    values: {
      [Roles.external]: "Externer Anwalt",
      [Roles.leadAccountmanager]: "Lead Accountmanager",
      [Roles.accountmanager]: "Operations",
      [Roles.accounting]: "Buchhaltung",
      [Roles.basicAccounting]: "Grundlagen Buchhaltung",
      [Roles.leadLawyer]: "Lead Anwalt",
      [Roles.lawyer]: "Interner Anwalt",
      [Roles.admin]: "Admin",
      [Roles.developer]: "Entwickler",
      [Roles.productManager]: "Produktmanager",
      [Roles.user]: "Benutzer",
      [Roles.system]: "System",
      [Roles.banking]: "Banking",
      [Roles.callcenter]: "Externer Kundenberater",
      [Roles.traineeLawyer]: "Referendar",
    },
  },
  status: {
    label: "Status",
    values: {
      inactive: "Deaktiviert",
      active: "Aktiv",
      invited: "Eingeladen",
    },
  },
  person: personTranslations,
};

export default backofficeUserTranslations;
